// Classic cart: a quantity change submits Woo's hidden "Update cart" button;
// Enter in the coupon field applies it (the disabled update button comes first in the form,
// so the browser's implicit submit would do nothing)

document.addEventListener('DOMContentLoaded', () => {
    if (!document.body.classList.contains('woocommerce-cart')) {
        return;
    }

    let updateTimer;

    // delegated on document - Woo's AJAX update replaces the whole cart form
    document.addEventListener('change', (event) => {
        if (!event.target.matches('.woocommerce-cart-form input.qty')) {
            return;
        }

        // deferred so Woo's own change handler has re-enabled the button first
        clearTimeout(updateTimer);
        updateTimer = setTimeout(() => {
            document.querySelector(".woocommerce-cart-form [name='update_cart']")?.click();
        }, 300);
    });

    document.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' || !event.target.matches('.woocommerce-cart-form #coupon_code')) {
            return;
        }

        event.preventDefault();
        event.target.form?.querySelector("[name='apply_coupon']")?.click();
    });
});
